import React from 'react';
import styled from 'styled-components';
import { getIsBreakpointGreaterThan } from '@peloton/responsive';
import { media } from '@peloton/styles';
import { gray3, slate2 } from '@engage/colors';
import { useReduxState } from '@engage/redux';
import { spaces } from '@engage/styles';
import { label10 } from '@engage/typography';
import { Friend } from '../icons/Friend';

const MAX_NUM_FRIENDS = 99;
const ONE_CHARACTER_BUBBLE_WIDTH = 16;
const TWO_CHARACTER_BUBBLE_WIDTH = 22;
const THREE_CHARACTER_BUBBLE_WIDTH = 29;

type Props = {
  num: number;
};

const getNumWidth = (strNum: string) => {
  switch (strNum.length) {
    case 1:
      return ONE_CHARACTER_BUBBLE_WIDTH;
    case 2:
      return TWO_CHARACTER_BUBBLE_WIDTH;
    case 3:
    default:
      return THREE_CHARACTER_BUBBLE_WIDTH;
  }
};

const NumberContainer = styled.div<{ numFriends: string }>`
  border-radius: 24px;
  height: 16px;
  width: ${p => getNumWidth(p.numFriends)}px;
  background-color: ${gray3};
  color: ${slate2};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  left: ${spaces.xLarge}px;
  top: -${spaces.xxxLarge + 2}px;
  ${label10}
`;

const NumberText = styled.p`
  padding-bottom: ${spaces.tiny}px;
`;

const StyledFriend = styled(Friend)`
  opacity: 0.8;
  height: 26px;
  width: 26px;
  ${media.desktop`
    height: 30px;
    width: 30px;
  `}
`;

const FriendsIconContainer = styled.div``;

export const Friends: React.FC<React.PropsWithChildren<Props>> = ({ num }) => {
  const isDesktop = useReduxState(getIsBreakpointGreaterThan, 'tabletXLarge');

  if (!num) {
    return null;
  }

  const numberOfFriends = num > MAX_NUM_FRIENDS ? `${MAX_NUM_FRIENDS}+` : `${num}`;
  return (
    <FriendsIconContainer>
      <StyledFriend data-test-id="friendsIcon" />
      {isDesktop ? (
        <NumberContainer numFriends={numberOfFriends}>
          <NumberText aria-label={numberOfFriends + ' friends have taken this class'}>
            {numberOfFriends}
          </NumberText>
        </NumberContainer>
      ) : null}
    </FriendsIconContainer>
  );
};
